import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { Gift, BookOpen, Check } from 'lucide-react';
export function OfferSection() {
  return <section className="py-20 px-4" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-[#E8820C]/20" data-id="element-72">
          <div className="bg-[#2D1B06] text-white text-center py-6 px-4" data-id="element-73">
            <h2 className="text-3xl font-bold uppercase tracking-wide" data-id="element-74">
              La Oferta Irresistible
            </h2>
            <p className="text-[#E8820C] font-medium mt-2" data-id="element-75">Solo por HOY</p>
          </div>

          <div className="p-8 sm:p-12" data-id="element-76">
            <ul className="space-y-4 mb-8" data-id="element-77">
              
              
              
            </ul>

            <div className="text-center mb-10" data-id="element-78">
              <p className="text-xl text-[#2D1B06]/60 font-medium mb-2" data-id="element-79">
                VALOR TOTAL: <span className="line-through" data-id="element-80">$82.74</span>
              </p>
              <div className="bg-[#FFF9F0] inline-block px-8 py-4 rounded-2xl border border-[#E8820C]/30" data-id="element-81">
                <p className="text-sm font-bold text-[#DC2626] uppercase tracking-wider mb-1" data-id="element-82">
                  Precio Especial Hoy
                </p>
                <p className="text-5xl font-extrabold text-[#2D1B06]" data-id="element-83">
                  $6.39 <span className="text-2xl text-[#2D1B06]/60" data-id="element-84">USD</span>
                </p>
              </div>
            </div>

            <CtaButton data-id="element-85" />
          </div>
        </motion.div>
      </div>
    </section>;
}